import { CircleNotch, DownloadSimple } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { useDownload } from "@/lib/download";

export default function FinalCta() {
  const { startDownload, downloading } = useDownload();

  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden border-t border-white/5 py-28 sm:py-36">
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 -z-10 h-[34rem] w-[34rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(0,245,160,0.12),transparent_65%)]"
      />
      <Reveal className="mx-auto max-w-3xl px-5 text-center sm:px-8">
        <h2 className="font-display text-4xl font-extrabold tracking-tighter text-slate-50 sm:text-6xl">
          Ready to Exchange <span className="text-[#00F5A0]">USDT to INR?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
          Download Coin Adda and start your exchange today.
        </p>
        <div className="mt-10">
          <button
            type="button"
            data-testid="final-cta-download-btn"
            onClick={startDownload}
            disabled={downloading}
            className="inline-flex items-center justify-center gap-3 rounded-full bg-[#00F5A0] px-10 py-5 text-lg font-bold text-[#050B14] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-[#00D68B] hover:shadow-[0_20px_60px_rgba(0,245,160,0.35)] disabled:opacity-70"
          >
            {downloading ? (
              <CircleNotch size={22} weight="bold" className="animate-spin" />
            ) : (
              <DownloadSimple size={22} weight="bold" />
            )}
            {downloading ? "Starting Download…" : "Download Coin Adda App"}
          </button>
        </div>
      </Reveal>
    </section>
  );
}
